import L from 'leaflet';

const ICON_SIZE = new L.Point(40, 40);

const bueno = new L.Icon({ iconUrl: require("../assets/bueno.svg").default, iconSize: ICON_SIZE });
const regular = new L.Icon({ iconUrl: require("../assets/regular.svg").default, iconSize: ICON_SIZE });
const alerta = new L.Icon({ iconUrl: require("../assets/alerta.svg").default, iconSize: ICON_SIZE });
const preemergencia = new L.Icon({ iconUrl: require("../assets/preemergencia.svg").default, iconSize: ICON_SIZE });
const emergencia = new L.Icon({ iconUrl: require("../assets/emergencia.svg").default, iconSize: ICON_SIZE });
const noDisponible = new L.Icon({ iconUrl: require("../assets/no_disponible.svg").default, iconSize: ICON_SIZE });

const Icons = {
    bueno,
    regular,
    alerta,
    preemergencia,
    emergencia,
    noDisponible,
};

export default Icons;